<template>
	<section class="modal j-popup j-omya-popup-2">
		<div class="modal__card" style="width:610px;">
			<div class="modal__image-holder">
				<img src="../../../static/images/maraphones/omya_3.jpg" width="100%" alt="" %>
			</div>
			<div class="modal__main">
				<p class="modal__text modal__text--large bold-font">Уважаемые коллеги!</p>

				<p class="modal__text">
					Стартовала вторая неделя нашего марафона. Ранее мы&nbsp;посетили координаты,
					которые оставил наш любознательный космонавт, но&nbsp;найти его пока не&nbsp;смогли:
					<nobr>из-за</nobr> больших космических расстояний данные о&nbsp;координатах проходят
					с&nbsp;задержкой и&nbsp;помехами, а&nbsp;космонавт успел сменить локацию, пытаясь выйти&nbsp;на&nbsp;орбиту.
				</p>
				<p class="modal__text">Сейчас он&nbsp;направился по&nbsp;следующим координатам:</p>
				<p class="modal__text">
					1)&nbsp;&nbsp;<span style="letter-spacing:2px;">1101000011011</span><br />
					2)&nbsp;&nbsp;<span style="letter-spacing:2px;">1000100000111</span><br />
					3)&nbsp;&nbsp;<span style="letter-spacing:2px;">1000000110000</span><br />
					4)&nbsp;&nbsp;<span style="letter-spacing:2px;">1100101001101</span>
				</p>
				<p class="modal__text">Чтобы помочь космонавту, расшифруйте шифр и&nbsp;пройдите 4&nbsp;загаданных курса.</p>
				<p class="modal__text">Напоминаем про действующие <a
						href="https://downloads.eduson.tv/materials/files/000/010/965/original/Регламент_марафона_Omya_(29.06.26).pdf"
						class="link-btn link-btn--underline bold-font"
						style="color: #58298b;"
						target="_blank"
						rel="noopener noreferrer"
					>
						правила спринта
					</a>.<br />
				Данный этап будет идти до&nbsp;12 июля. Приятного обучения!</p>
			</div>
			<div class="text-center" style="background-color: #1a1734;border-radius: 0 0 5px 5px;padding: 40px;">
				<button
					class="regular-btn red-white-btn bold-font j-upd-additional-info j-hide-popup"
					:data-url="upd_additional_info_path"
					data-additional-info="omya_06_26_2"
					type="button"
				>Участвую!</button>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OmyaPopup2',

	props: {
		upd_additional_info_path: ''
	},

	data() {
		return {
			isShow: false
		}
	},

	methods: {
		closePopup() {
		},
	},
}
</script>

